import moment from 'moment'
import Calendar from 'react-calendar'

export default function CalendarRangePicker({
  limitToMonth,
  startDate,
  endDate,
  onDateChange,
  allowFutureDates = false,
  selectRange = true,
}: {
  limitToMonth: boolean
  startDate: moment.Moment
  endDate: moment.Moment
  onDateChange: (dates: Date[]) => void
  allowFutureDates?: boolean
  selectRange?: boolean
}) {
  return (
    <Calendar
      defaultView={limitToMonth ? `year` : `month`}
      maxDetail={limitToMonth ? `year` : `month`}
      maxDate={allowFutureDates ? undefined : new Date()}
      className="range-picker date-picker"
      tileClassName="my-1 py-3"
      onChange={(dates) => {
        if (!Array.isArray(dates) || !dates[0] || !dates[1]) return
        onDateChange([dates[0], dates[1]])
      }}
      value={[startDate.startOf(`day`).toDate(), endDate.endOf(`day`).toDate()]}
      selectRange={selectRange}
      goToRangeStartOnSelect={false}
      defaultActiveStartDate={endDate.endOf(`day`).toDate()}
      calendarType="gregory"
    />
  )
}
